module.exports = __webpack_public_path__ + "img/oil.acc39ae0.png";